import React from "react";
import ListDocumentiFirmatiController from "./components/list_doc_firmati/ListDocumentiFirmatiController";

export default function ListDocumentiFirmati() {

    return (
        <ListDocumentiFirmatiController/>
    );
}